const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 38 38",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6300_99082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6300_99082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9479 18.4339C20.6216 17.701 21.12 16.8596 21.443 15.9096C21.7657 14.9596 21.9271 13.9802 21.9271 12.9714C21.9271 11.9625 21.7657 10.9831 21.443 10.0331C21.12 9.08308 20.6216 8.24167 19.9479 7.50885C21.3383 7.6693 22.4929 8.26965 23.4115 9.3099C24.3298 10.3504 24.789 11.5709 24.789 12.9714C24.789 14.3721 24.3298 15.5926 23.4115 16.6328C22.4929 17.6731 21.3383 18.2734 19.9479 18.4339ZM28.2604 30.5709V26.856C28.2604 25.9928 28.0848 25.1716 27.7336 24.3923C27.3823 23.6131 26.884 22.9444 26.2385 22.3862C27.4524 22.7903 28.5698 23.3353 29.5908 24.0214C30.6118 24.7075 31.1223 25.6524 31.1223 26.856V30.5709H28.2604ZM36.664 17.0211H27.9556V14.6461H36.664V17.0211ZM13.2188 18.513C11.6948 18.513 10.3901 17.9705 9.30475 16.8854C8.21964 15.8 7.67708 14.4953 7.67708 12.9714C7.67708 11.4474 8.21964 10.1429 9.30475 9.05775C10.3901 7.97238 11.6948 7.42969 13.2188 7.42969C14.7427 7.42969 16.0472 7.97238 17.1324 9.05775C18.2177 10.1429 18.7604 11.4474 18.7604 12.9714C18.7604 14.4953 18.2177 15.8 17.1324 16.8854C16.0472 17.9705 14.7427 18.513 13.2188 18.513ZM1.34375 30.5709V27.0507C1.34375 26.2754 1.55433 25.5574 1.9755 24.8966C2.39667 24.2358 2.95941 23.7279 3.66373 23.3727C5.22885 22.6055 6.8077 22.0301 8.40027 21.6464C9.99258 21.2627 11.5987 21.0709 13.2188 21.0709C14.8385 21.0709 16.4447 21.2627 18.0372 21.6464C19.6295 22.0301 21.2083 22.6055 22.7734 23.3727C23.4777 23.7279 24.0404 24.2358 24.4616 24.8966C24.883 25.5574 25.0938 26.2754 25.0938 27.0507V30.5709H1.34375Z",
    style: {
      fill: "color(display-p3 0.3765 0.3725 0.3804)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMinus);
export default __webpack_public_path__ + "static/media/GroupMinus.f5819538850fbf1fe6fd3585dd7af389.svg";
export { ForwardRef as ReactComponent };